import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { firstValueFrom, Observable, tap } from 'rxjs';
import { AuthService } from '../auth.service';
import { UserRole } from 'app/core/roles/roles.model';

@Injectable({
    providedIn: 'root',
})
export class RoleGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.authService
            .getJwtCookie()
            .then((result) => {
                const roles: UserRole[] = route.data.roles as UserRole[];

                for (const role of roles) {
                    if (result.includes(role)) {
                        return true;
                    }
                }
                this.redirectTonotFound();
                return false;
            })
            .catch((error) => {
                console.error('Error in RoleGuard:', error);
                return false;
            });
    }

    redirectTonotFound() {
        this.router.navigate(['404-not-found']);
    }
}
